import {create} from 'zustand';

import {WEB_VIEW_MESSAGES} from '@/services/webview/constants';
import {WebViewService} from '@/services/webview/WebViewService';
import {isLocalhost} from '@/utils/environment';

interface StoreState {
  isLoading: boolean;
  skipLoading: boolean;
  startLoading: () => void;
  stopLoading: () => void;
  setSkipLoading: (isSkipped: boolean) => void;
}

const showNativeLoader = (show: boolean) => {
  if (
    typeof window.ReactNativeWebView !== 'undefined' &&
    window.ReactNativeWebView
  ) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        status: show
          ? WEB_VIEW_MESSAGES.SHOW_LOADER_TRUE
          : WEB_VIEW_MESSAGES.SHOW_LOADER_FALSE,
      }),
    );
    return;
  }
};

export const useLoading = create<StoreState>(set => ({
  isLoading: false,
  skipLoading: false,
  startLoading: () => {
    if (WebViewService.isWebViewActive()) {
      showNativeLoader(true);
      return;
    }
    set({isLoading: true});
  },
  stopLoading: () => {
    if (WebViewService.isWebViewActive()) {
      showNativeLoader(false);
      return;
    }
    set({isLoading: false});
  },
  setSkipLoading: (isSkipped: boolean) => {
    if (isLocalhost) console.log('setSkipLoading', isSkipped);
    set({skipLoading: isSkipped});
  },
}));
